import React from "react";
import { Link } from "react-router-dom";
import { Panel, PanelBody } from "./../components/panel/panel.jsx";
import { Api } from "./../app-controller.js";
import Swal from "sweetalert2";

class ProductsClassifications extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      buscarProductos: {},
      estatusTramiteCombo: Api.loadCatalogue("cat_estatus_tramite"),
      nivelUsuario: localStorage.nivel_actual,
    };

    this.handleClasificacionProd = this.handleClasificacionProd.bind(this);
  }

  clasificacion = "";
  mi_grid = {};
  componentDidMount() {
    // si el usuario no es nivel drycip redireccionamos a home
    if (this.state.nivelUsuario !== "3") {
      window.location.href = "/";
    }

    let grid = {
      source: "app/getProductosClasificar",
      target: "#myGrid",
      tableClass: "table table-striped m-b-0 table-hover",
      rowsPerPage: [5, 10, 25, 50, 100],
      progressText: "Cargando datos",
      rows: {
        nombre_comercial: {
          label: "Nombre Comercial",
          render: (me) => {
            if (me.data.nombre_comercial !== null) {
              me.innerHTML = me.data.nombre_comercial;
            } else {
              me.innerHTML = "";
            }
          },
        },
        /* tipo_producto: {
          label: "Tipo producto",
          render: (me) => {
            if (me.data.tipo_producto !== "Null") {
              me.innerHTML = me.data.tipo_producto;
            } else {
              me.innerHTML = "NA";
            }
          },
        },
        estatus_producto: {
          label: "Estado producto",
          render: (me) => {
            if (me.data.estatus_producto !== null) {
              me.innerHTML = me.data.estatus_producto;
            } else {
              me.innerHTML = "";
            }
          },
        }, */
        pais: {
          label: "País de origen",
          render: (me) => {
            if (me.data.pais !== null) {
              me.innerHTML = me.data.pais;
            } else {
              me.innerHTML = "";
            }
          },
        },
        no_registro_drycip: {
          label: "Número de registro",
          render: (me) => {
            if (me.data.no_registro_drycip !== null) {
              me.innerHTML = me.data.no_registro_drycip;
            } else {
              me.innerHTML = "";
            }
          },
        },
        no_registro: {
          label: "Identificador del sistema",
          render: (me) => {
            if (me.data.no_registro !== null) {
              me.innerHTML = me.data.no_registro;
            } else {
              me.innerHTML = "";
            }
          },
        },
        grupo_ingrediente: {
          label: "Grupo de riesgo",
          render: (me) => {
            if (me.data.grupo_ingrediente !== null) {
              me.innerHTML = me.data.grupo_ingrediente;
            } else {
              me.innerHTML = "";
            }
          },
        },
        clase_producto: {
          label: "Clasificación",
          render: (me) => {
            if (me.data.clase_producto !== null) {
              me.innerHTML = me.data.clase_producto;
            } else {
              me.innerHTML = "";
            }
          },
        },
        categorizacion: {
          label: "Categoría de venta",
          render: (me) => {
            if (me.data.categorizacion !== null) {
              me.innerHTML = me.data.categorizacion;
            } else {
              me.innerHTML = "";
            }
          },
        },
        estatus_producto: {
          label: "Estado producto",
          render: (me) => {
            if (me.data.estatus_producto !== null) {
              me.innerHTML = me.data.estatus_producto;
            } else {
              me.innerHTML = "";
            }
          },
        },
      },
      buttons: [
        {
          iconClass: "fa fa-list",
          btnClass: "btn bg-gradient-green",
          btnClick: (data) => {
            this.handleClasificacionProd(data);
          },
          render: (me, data) => {},
        },
      ],
    };

    this.mi_grid = Api.grid(grid);

    let busqueda = Api.form({
      target: "#busqueda",
      /*onchange: (me, data, serial) => {
                mi_grid.go(1, serial);
            },*/
      render: (form) => {
        /** Cargamos el combo de pais */
        let paises = Api.loadCatalogue("countries");
        let option_p = "<option value=''>Seleccione país</option>";
        for (let p in paises) {
          option_p += `<option value="${paises[p].id}">
                        ${paises[p].descripcion}
                    </option>`;
        }
        form.querySelector("#pais").innerHTML = option_p;
        /* Fin de la carga país */

        let grupo = Api.loadCatalogue("cat_grupo_ingrediente");
        let option_g = "<option value=''>Seleccione grupo de riesgo</option>";
        for (let p in grupo) {
          option_g += `<option value="${grupo[p].id}">
                        ${grupo[p].descripcion}
                    </option>`;
        }
        form.querySelector("#grupo_ingrediente_id").innerHTML = option_g;
        /* Fin de la carga país */

        let clase = Api.loadCatalogue("cat_clase_productos");
        let option_c = "<option value=''>Seleccione clase</option>";
        for (let p in clase) {
          option_c += `<option value="${clase[p].id}">
                        ${clase[p].descripcion}
                    </option>`;
        }
        form.querySelector("#clase_producto_id").innerHTML = option_c;
        /* Fin de la carga país */

        let categorizacion = Api.loadCatalogue("cat_categorizacion_oficial");
        let option_ct = "<option value=''>Seleccione categoría</option>";
        for (let p in categorizacion) {
          option_ct += `<option value="${categorizacion[p].id}">
                        ${categorizacion[p].descripcion}
                    </option>`;
        }
        form.querySelector("#categorizacion_oficial_id").innerHTML = option_ct;
        /* Fin de la carga país */

        /** Cargamos el combo de estatus */
        Api.fetch("app/getEstatusProducto").then((data) => {
          if (data) {
            let estatus = data;
            let option_e = `<option value=''>Seleccione el estatus producto</option>`;
            for (let e in estatus) {
              option_e += `<option value="${estatus[e].id}">${estatus[e].descripcion}</option>`;
            }
            form.querySelector("#estatus").innerHTML = option_e;
          }
        });
        /* Fin de la carga estatus */
      },

      elementClass: "form-control",
      elements: [
        {
          input: {
            type: "text",
            name: "nombre_comercial",
            label: "Nombre comercial",
            placeHolder: "Nombre comercial",
            cols: 2,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "pais",
            label: "País de origen",
            placeHolder: "País de origen",
            cols: 2,
            value: "",
          },
        },
        {
          input: {
            type: "number",
            name: "no_registro_drycip",
            label: "Número de registro",
            placeHolder: "Número de registro",
            cols: 2,
            value: "",
            autoComplete: "off",
            maxLength: "4",
            min: "1",
          },
        },
        {
          input: {
            type: "number",
            name: "no_registro",
            label: "Identificador del sistema",
            placeHolder: "Identificador del sistema",
            cols: 3,
            value: "",
            autoComplete: "off",
            maxLength: "4",
            min: "1",
          },
        },
        {
          select: {
            type: "text",
            name: "grupo_ingrediente_id",
            label: "Grupo riesgo",
            placeHolder: "Grupo riesgo",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "clase_producto_id",
            label: "Clasificación de producto",
            placeHolder: "Clasificación de producto",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "categorizacion_oficial_id",
            label: "Categoría de venta",
            placeHolder: "Categoría de venta",
            cols: 3,
            value: "",
          },
        },
        {
          select: {
            type: "text",
            name: "estatus",
            label: "Estado producto",
            placeHolder: "Estado producto",
            cols: 3,
            value: "",
          },
        },
        {
          button: {
            name: "buscar",
            class: "form-control btn-orange",
            icon: "fa fa-search",
            cols: 3,
            text: "Buscar",
            click: (e) => {
              this.setState({ buscarProductos: busqueda.data() });
              let search = this.state.buscarProductos;

              let src = "";
              for (let param in search) {
                if (search[param] !== "") {
                  src += "&" + param + "=" + search[param];
                }
              }

              this.mi_grid.go(1, src);
            },
          },
        },
      ],
    });

    let formaClasificacion = {
      target: "#clasificacion",
      nombre: "clasificacion",
      elementClass: "form-control",
      render: (me) => {
        let ingredientes = Api.loadCatalogue("cat_grupo_ingrediente");
        let grupotpl = "<option value=''>Seleccione grupo</option>";
        for (let ingrediente in ingredientes) {
          grupotpl += `<option value="${ingredientes[ingrediente].id}">
                ${ingredientes[ingrediente].descripcion}
            </option>`;
        }
        me.querySelector("#grupo_ingrediente_id").innerHTML = grupotpl;

        //me.querySelector("#clase_producto_id").innerHTML = "<option value=''>Cargando espere...</option>";

        let cates = Api.loadCatalogue("cat_categorizacion_oficial");
        let catesTpl = "<option value=''>Seleccione clase</option>";
        for (let cate in cates) {
          catesTpl += `<option value="${cates[cate].id}">
                ${cates[cate].descripcion}
            </option>`;
        }
        me.querySelector("#categorizacion_oficial_id").innerHTML = catesTpl;
      },
      elements: [
        {
          select: {
            cols: 12,
            name: "grupo_ingrediente_id",
            label: "Grupo de riesgo<span class='text-danger'>*</span>",
          },
        },
        {
          select: {
            cols: 12,
            name: "clase_producto_id",
            label:
              "Clasificación de producto<span class='text-danger'>*</span>",
          },
        },
        {
          select: {
            cols: 12,
            name: "categorizacion_oficial_id",
            label: "Categoría de venta<span class='text-danger'>*</span>",
          },
        },
        {
          input: {
            cols: 6,
            type: "text",
            name: "tomo",
            label: "Tomo<span class='text-danger'>*</span>",
          },
        },
        {
          input: {
            cols: 6,
            type: "text",
            name: "folio",
            label: "Folio<span class='text-danger'>*</span>",
          },
        },
        {
          input: {
            cols: 6,
            type: "number",
            name: "no_registro_drycip",
            label: "Número de registro<span class='text-danger'>*</span>",
            min: "1",
          },
        },
        {
          input: {
            cols: 6,
            type: "text",
            name: "dossier",
            label: "Dossier<span class='text-danger'>*</span>",
          },
        },
      ],
    };

    this.clasificacion = Api.form(formaClasificacion);
  }

  handleClasificacionProd(e) {
    this.clasificacion.clear();
    let rset = e;
    //### Si tipo producto veterinario <= 3 entonces mostramos el combo de clasificar si no lo ocultamos
    this.clasificacion.querySelector(".clase_producto_id").classList =
      "clase_producto_id";

    if (parseInt(rset.tipo_producto_veterinario_id) <= 3) {
      this.clasificacion.querySelector("#clase_producto_id").innerHTML =
        "<option value=''>Cargando espere...</option>";
      Api.fetch(
        "app/getCatClasificacionProVet?id=" + rset.tipo_producto_veterinario_id
      ).then((r) => {
        let tpl = `<option value=''>Seleccione clase</option>`;
        for (let i in r) {
          tpl += `<option value=${r[i].id}>${r[i].descripcion}</option>`;
        }
        this.clasificacion.querySelector("#clase_producto_id").innerHTML = tpl;
        this.clasificacion.querySelector("#clase_producto_id").value =
          rset.clase_producto_id == null ? "" : rset.clase_producto_id;
      });
    } else {
      this.clasificacion.querySelector(".clase_producto_id").classList =
        "clase_producto_id hide";
    }

    this.clasificacion.querySelector("#grupo_ingrediente_id").value =
      rset.grupo_ingrediente_id == null ? "" : rset.grupo_ingrediente_id;
    this.clasificacion.querySelector("#categorizacion_oficial_id").value =
      rset.categorizacion_oficial_id == null
        ? ""
        : rset.categorizacion_oficial_id;
    this.clasificacion.querySelector("#tomo").value = rset.tomo;
    this.clasificacion.querySelector("#no_registro_drycip").value =
      rset.no_registro_drycip;
    this.clasificacion.querySelector("#folio").value = rset.folio;
    this.clasificacion.querySelector("#dossier").value = rset.dossier;

    Swal.fire({
      title: "Clasifique este producto",
      html: this.clasificacion,
      showCancelButton: true,
      confirmButtonText: "Clasificar",
      showLoaderOnConfirm: true,
      reverseButtons: true,
      cancelButtonText: "Regresar",
      cancelButtonColor: "Red",
      confirmButtonColor: "#4CD964",
      /*   customClass: {
        validationMessage: 'my-validation-message'
      }, */
      preConfirm: () => {
        let dataForm = this.clasificacion.data();
        let pass = 1;
        if (dataForm.grupo_ingrediente_id === "0") {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (parseInt(rset.tipo_producto_veterinario_id) <= 3) {
          if (dataForm.clase_producto_id === "0") {
            //resolve("Seleccione la clase del producto");
            Swal.showValidationMessage("Seleccione");
            pass = 0;
          }
        }

        if (dataForm.dossier === "" || !dataForm.dossier) {
          Swal.showValidationMessage("Ingrese dossier");
          pass = 0;
        }

        if (
          dataForm.no_registro_drycip === "" ||
          !dataForm.no_registro_drycip
        ) {
          Swal.showValidationMessage("Ingrese el número de registro");
          pass = 0;
        }

        if (dataForm.folio === "" || !dataForm.folio) {
          Swal.showValidationMessage("Ingrese el folio");
          pass = 0;
        }

        if (dataForm.tomo === "" || !dataForm.tomo) {
          Swal.showValidationMessage("Ingrese el tomo");
          pass = 0;
        }

        if (dataForm.categorizacion_oficial_id === "0") {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (dataForm.grupo_ingrediente_id === "0") {
          Swal.showValidationMessage("Seleccione");
          pass = 0;
        }

        if (pass) {
          return Api.fetch(
            "app/clasificarProducto",
            {
              clasificacion: dataForm,
              id: e.id,
            },
            "POST"
          ).then((r) => {
            Swal.fire({
              icon: "success",
              title: "Clasificación exitosa.",
              text: r.message,
            });
            this.mi_grid.go(1);
          });
        }
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
  }

  render() {
    return (
      <div>
        <ol className="breadcrumb float-xl-right">
          <li className="breadcrumb-item">
            <Link to="/">Inicio</Link>
          </li>
          <li className="breadcrumb-item active">Clasificación de productos</li>
        </ol>
        <h1 className="page-header">Productos</h1>
        <Panel>
          <PanelBody>
            <div className="row">
              <div className="col-sm-12">
                <fieldset>
                  <div id="busqueda"></div>
                </fieldset>
                <div id="myGrid"></div>
              </div>
            </div>
          </PanelBody>
        </Panel>
      </div>
    );
  }
}

export default ProductsClassifications;
